import React from "react";

import { Provider } from "react-redux";
import store from "./stores";

import Router from "./Router";

import "./App.css";
console.disableYellowBox = true;

export default function App() {
  return (
    <Provider store={store}>
      <Router />
    </Provider>
  );
}
